window.addEventListener("DOMContentLoaded", () => {
  (($) => {
    console.log('DOMContentLoaded')
    if($( ".customer-b2b" ).val() != 'true' && getCookie('discount_code') == "FLSUMMIT23"){
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', 'UHZV8J']);
      } 
    if($( ".customer-b2b" ).val() != 'true' && getCookie('discount_code') == "DAVE15"){
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', 'RjBZGH']); 
      }
    if($( ".customer-b2b" ).val() != 'true' && getCookie('discount_code') == "DAVE"){
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', 'VSJpM8']); 
      }
    if($( ".customer-b2b" ).val() != 'true' && getCookie('discount_code') == "HEARTSUMMIT24"){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'Ue7quP']); 
      }

    
    $('.image-zoom')
                .css('display', 'block')
                .parent()
                .zoom({
                    url: $(this).find('img').attr('data-zoom'),
                    magnify: 1
                });
    
    $(".readmore").on("click", function (event) {
      event.preventDefault();
      var descriptionFull = $(".product-description-full");
      descriptionFull.css("display", "block");
      var descriptionShort = $(".product-description-short");
      descriptionShort.css("display", "none");
    });

    $(".readless").on("click", function (event) {
      event.preventDefault();
      var descriptionFull = $(".product-description-full");
      descriptionFull.css("display", "none");
      var descriptionShort = $(".product-description-short");
      descriptionShort.css("display", "block");
    });
  })(jQuery);
});
